/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable default-case */
import { SECTION_NAMES } from '../schemas/formAdvancedSections';
import { FORM_COMPONENT_BASIC_INPUT_TYPE } from '../schemas/formComponentInputTypeSchema';
import { FormAddItemPayload, FormBuilderState } from '../store/formBuilderModel';
import { FormItemT } from '../types';
import {
  addItemByPath,
  adjustTargetPathAfterRemoval,
  createNewSection,
  findItemByPath,
  isFieldSchema,
  isSectionSchema,
  removeItemByPath,
} from '../utils';

function removeSecondLastItem(arr: number[]): number[] {
  if (arr.length < 2) return [...arr];

  const indexToRemove = arr.length - 2;
  return [...arr.slice(0, indexToRemove), ...arr.slice(indexToRemove + 1)];
}

export function moveToCanvas(state: FormBuilderState, action: FormAddItemPayload) {
  const { draggedItem, dropTarget } = action;

  function resetState(formSchema?: FormItemT[]): FormBuilderState {
    return {
      ...state,
      formSchema: formSchema ?? state.formSchema,
      draggedItem: null,
      dropIndicator: undefined,
      scrollToItemId: null,
    };
  }
  if (!draggedItem || draggedItem.type !== 'formItem' || !draggedItem.sourcePath || dropTarget.path.length !== 1) {
    return resetState();
  }

  let itemToMove = draggedItem.itemData as FormItemT;
  let sourcePath = [...draggedItem.sourcePath];
  if (itemToMove.optionId) {
    sourcePath = [...removeSecondLastItem(dropTarget.path)];
  }

  const schemaAfterRemoval = removeItemByPath(state.formSchema, sourcePath);
  if (!schemaAfterRemoval) {
    return resetState();
  }

  const adjustedDropTargetPath = adjustTargetPathAfterRemoval(sourcePath, dropTarget.path);
  if (!adjustedDropTargetPath) {
    return resetState();
  }
  const parentPathForAdd = adjustedDropTargetPath.slice(0, -1);
  const insertionIndexForAdd = adjustedDropTargetPath[adjustedDropTargetPath.length - 1];
  if (isFieldSchema(itemToMove)) {
    const defaultText = `${itemToMove.inputType}`;

    const section = createNewSection(state.formSchema, `${defaultText} Section`);
    section.fields = [itemToMove];
    itemToMove = section;
  }
  const newSchema = addItemByPath(schemaAfterRemoval, parentPathForAdd, insertionIndexForAdd, itemToMove);
  if (!newSchema) {
    return resetState();
  }

  return resetState(newSchema);
}
export function moveToSection(state: FormBuilderState, action: FormAddItemPayload) {
  const { draggedItem, dropTarget } = action;

  function resetState(formSchema?: FormItemT[]): FormBuilderState {
    return {
      ...state,
      formSchema: formSchema ?? state.formSchema,
      draggedItem: null,
      dropIndicator: undefined,
      scrollToItemId: null,
    };
  }

  if (!draggedItem || draggedItem.type !== 'formItem' || !draggedItem.sourcePath) {
    return resetState();
  }

  const itemToMove = draggedItem.itemData as FormItemT;
  let sourcePath = [...draggedItem.sourcePath];
  if (itemToMove.optionId) {
    sourcePath = [...removeSecondLastItem(draggedItem.sourcePath)];
  }
  const parentItem = findItemByPath(state.formSchema, dropTarget.path.slice(0, -1));

  if (!parentItem || (isSectionSchema(parentItem) && parentItem.isAdvanced)) {
    return resetState();
  }
  // remove section within section
  if (parentItem && isSectionSchema(parentItem) && isSectionSchema(itemToMove) && !itemToMove.isAdvanced) {
    return resetState();
  }

  const schemaAfterRemoval = removeItemByPath(state.formSchema, sourcePath);
  if (!schemaAfterRemoval) {
    return resetState();
  }

  const adjustedDropTargetPath = adjustTargetPathAfterRemoval(sourcePath, dropTarget.path);
  if (!adjustedDropTargetPath) {
    return resetState();
  }
  const parentPathForAdd = adjustedDropTargetPath.slice(0, -1);
  const insertionIndexForAdd = adjustedDropTargetPath[adjustedDropTargetPath.length - 1];

  const newSchema = addItemByPath(schemaAfterRemoval, parentPathForAdd, insertionIndexForAdd, itemToMove);
  if (!newSchema) {
    return resetState(schemaAfterRemoval);
  }

  return resetState(newSchema);
}
export function moveToFollowUp(state: FormBuilderState, action: FormAddItemPayload) {
  const { draggedItem, dropTarget, optionId } = action;

  const targetPath = removeSecondLastItem(dropTarget.path);
  const sourceItem = draggedItem?.itemData as FormItemT;
  let sourcePath = [...draggedItem?.sourcePath!];
  if (sourceItem.optionId) {
    sourcePath = removeSecondLastItem(draggedItem?.sourcePath ?? []);
  }

  function resetState(formSchema?: FormItemT[]): FormBuilderState {
    return {
      ...state,
      formSchema: formSchema ?? state.formSchema,
      draggedItem: null,
      dropIndicator: undefined,
      scrollToItemId: null,
    };
  }

  if (!draggedItem || draggedItem.type !== 'formItem' || !sourcePath) {
    return resetState();
  }

  const itemToMove = draggedItem.itemData as FormItemT;
  const parentItem = findItemByPath(state.formSchema, targetPath.slice(0, -1));
  if (isFieldSchema(itemToMove)) {
    switch (itemToMove.inputType) {
      case FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo:
        return resetState();
      case FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview:
        return resetState();
    }
  } else if (isSectionSchema(itemToMove)) {
    if (!itemToMove.isAdvanced) {
      return resetState();
    }
    if (itemToMove.section === SECTION_NAMES.fullName) {
      return resetState();
    }
    if (itemToMove.section === SECTION_NAMES.emergencyContact) {
      return resetState();
    }
  }
  if (!parentItem || (isSectionSchema(parentItem) && parentItem.isAdvanced)) {
    return resetState();
  }
  // remove section within section
  if (parentItem && isSectionSchema(parentItem) && isSectionSchema(itemToMove) && !itemToMove.isAdvanced) {
    return resetState();
  }

  const schemaAfterRemoval = removeItemByPath(state.formSchema, sourcePath);
  if (!schemaAfterRemoval) {
    return resetState();
  }

  const adjustedDropTargetPath = adjustTargetPathAfterRemoval(sourcePath, targetPath);
  if (!adjustedDropTargetPath) {
    return resetState();
  }
  const parentPathForAdd = adjustedDropTargetPath.slice(0, -1);
  const insertionIndexForAdd = adjustedDropTargetPath[adjustedDropTargetPath.length - 1];

  const newSchema = addItemByPath(schemaAfterRemoval, parentPathForAdd, insertionIndexForAdd, itemToMove, optionId);
  if (!newSchema) {
    return resetState(schemaAfterRemoval);
  }

  return resetState(newSchema);
}
